import React from 'react';
import { FadeIn, Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section className="pt-12 md:pt-20 pb-0 md:pb-12 overflow-hidden" data-id="element-34">
      <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-35">
        {/* Left Content */}
        <div className="flex-1 space-y-8" data-id="element-36">
          <FadeIn data-id="element-37">
            <div className="inline-block px-4 py-1.5 rounded-full bg-[#E8E2D9] text-[#4A3728] text-sm font-medium tracking-wide mb-6" data-id="element-38">
              EDICIÓN 2026 (USA) • ESPAÑOL
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-[1.15] text-[#4A3728] mb-6" data-id="element-39">
              Si te da ansiedad abrir tu banco,{' '}
              <span className="text-[#C4956A] italic" data-id="element-40">empieza aquí.</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} className="space-y-6 text-lg text-[#6B5D52] leading-relaxed" data-id="element-41">
            <p data-id="element-42">
              Hay un tipo de cansancio que no se ve. No es físico. Es ese nudo
              en el pecho cuando piensas en dinero.
            </p>
            <p data-id="element-43">
              No porque no trabajes. No porque "no te importe". Sino porque
              abrir el banco se siente como abrir una puerta a la vergüenza.
            </p>
            <p className="font-medium text-[#4A3728]" data-id="element-44">
              Este PDF no es para enseñarte "finanzas". Es para darte un plan
              cuando estás en pánico.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="pt-4" data-id="element-45">
            <Button onClick={scrollToPricing} className="w-full md:w-auto group" data-id="element-46">
              Quiero mi Plan Antipánico
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-47" />
            </Button>
            <p className="mt-4 text-sm text-[#8C7B70]" data-id="element-48">
              Sin apps. Sin Excel complicado. Sin culpa.
            </p>
          </FadeIn>
        </div>

        {/* Right Image */}
        <FadeIn delay={0.3} className="flex-1 w-full relative" data-id="element-49">
          <div className="relative w-full max-w-lg mx-auto" data-id="element-50">
            {/* Main Image — multi-device mockup */}
            <img src="https://cdn.magicpatterns.com/uploads/a5NzikThH1bDaBUDdRaDRD/heylloyd-image-1770567635990.png" alt="Plan Antipánico mostrado en laptop, tablet y teléfono" className="relative z-10 w-full h-auto rounded-xl" data-id="element-51" />
          </div>
        </FadeIn>
      </div>
    </Section>;
}